export var NEW_RELIC_SCRIPT = 'NEW_RELIC_SCRIPT';
export var NEW_RELIC_SCRIPT_SET = 'NEW_RELIC_SCRIPT_SET';